import {
  Text,
  Textarea,
  Button,
  Stack,
  Box,
  Badge,
  Group,
  Accordion,
} from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { useLocation } from "wouter";
import { useStore } from "../store";
// import { getCustomModels } from "../api";

function SourceBadge({ imageData }) {
  const sourceType = imageData.sourceType;
  switch (sourceType) {
    case "UserUploaded":
      return (
        <Badge variant="light" color="blue" radius="sm">
          Uploaded
        </Badge>
      );
    case "Generated":
      return (
        <Badge variant="light" color="grape" radius="sm">
          Generated
        </Badge>
      );
    case "UserEnhanced":
      return (
        <Badge variant="light" color="yellow" radius="sm">
          Enhanced
        </Badge>
      );
    default:
      return (
        <Badge variant="light" color="red" radius="sm">
          {sourceType}
        </Badge>
      );
  }
}

export default function ImageInfo({ imageData, pixelImage }) {
  const [, setLocation] = useLocation();
  const setGeneratorConfig = useStore((state) => state.setGeneratorConfig);

  return (
    <Accordion>
      <Accordion.Item value="image-info">
        <Accordion.Control>
          <Group mr="sm" justify="space-between" align="center">
            Details
            <Text>
              {pixelImage?.width} &#x2A2F; {pixelImage?.height}
            </Text>
            <SourceBadge imageData={imageData} />
          </Group>
        </Accordion.Control>
        <Accordion.Panel>
          <Stack gap="xs">
            {imageData?.pluginTitle && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Plugin
                </Text>
                <Text>{imageData.pluginTitle}</Text>
              </Box>
            )}

            {imageData?.pluginTitle && imageData?.pluginFilterLabel && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Filter
                </Text>
                <Text>{imageData.pluginFilterLabel}</Text>
              </Box>
            )}

            {imageData?.pluginPresetLabel && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Preset
                </Text>
                <Text>{imageData.pluginPresetLabel}</Text>
              </Box>
            )}

            {(imageData?.pluginInputs ?? []).map((row) => (
              <Box key={row.label || row.value}>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  {row.label}
                </Text>
                <Text>{row.value}</Text>
              </Box>
            ))}

            {imageData?.pluginPrompt && (
              <Box>
                <Text fz="xs" mb="xs" fw={600} tt="uppercase" c="dimmed">
                  Prompt
                </Text>
                <Textarea
                  value={imageData.pluginPrompt}
                  minRows={2}
                  maxRows={12}
                  autosize
                  disabled
                />
              </Box>
            )}

            {imageData?.pluginSeed != null && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Seed
                </Text>
                <Text>{imageData.pluginSeed}</Text>
              </Box>
            )}

            <Box>
              <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                Resolution
              </Text>
              <Text>
                {pixelImage?.width} &#x2A2F; {pixelImage?.height}
              </Text>
            </Box>

            {/* {imageData.generateConfig?.customModelId && (
        <Box>
          <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
            Model
          </Text>
          <Text>{imageData.generateConfig.customModelId}</Text>
        </Box>
      )} */}

            {imageData.generateConfig?.config && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Config
                </Text>
                {Object.entries(imageData.generateConfig.config).map(
                  ([key, value]) => (
                    <Group key={key} gap="xs">
                      <Text>{key}:</Text>
                      <Badge radius="xs" color="gray">
                        {value}
                      </Badge>
                    </Group>
                  )
                )}
              </Box>
            )}

            {imageData.generateConfig?.styleTemplateName && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Style
                </Text>
                <Text>{imageData.generateConfig.styleTemplateName}</Text>
              </Box>
            )}

            <Box>
              <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                Taken / Uploaded
              </Text>
              <Text>{imageData.created}</Text>
            </Box>
            {!imageData.pluginTitle && imageData.generateConfig?.prompt && (
              <Box>
                <Text fz="xs" mb="xs" fw={600} tt="uppercase" c="dimmed">
                  Original Prompt
                </Text>
                <Textarea
                  value={imageData.generateConfig.prompt}
                  minRows={3}
                  maxRows={15}
                  autosize
                  disabled
                />
              </Box>
            )}

            {imageData.generateConfig?.seed && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Seed
                </Text>
                <Text>{imageData.generateConfig.seed}</Text>
              </Box>
            )}
            {imageData.generateConfig && (
              <Button
                mt="xs"
                variant="light"
                onClick={() => {
                  setGeneratorConfig(imageData.generateConfig);
                  setLocation("/generate");
                }}
                rightSection={<IconArrowRight />}
              >
                Generate similar
              </Button>
            )}
          </Stack>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}
